import { BASE_URL } from '../constants';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { errorHandling, errorHandler } from '../utils/errorHandling';

class sendNotificationApi {
    static doSendNotification(request) {
        const TOKEN = getItem('auth_token');
        let isError = false;
        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': TOKEN
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: JSON.stringify(request)
            }
            return fetch(BASE_URL + `/users/send_notifications`, body).then(response => {
                if (response.ok === true) {
                    Swal.fire({
                        title: 'Send Notification Successfully',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        timer: 3000,
                        heightAuto: false
                    })
                }
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
    static doAttachment(file) {
        const TOKEN = getItem('auth_token');
        const data = new FormData();
        data.append('file', file[0]);
        let isError = false;
        try{
            const ajaxRequestHeaders = new Headers({
                'Authorization': TOKEN,
                mimeType: 'multipart/form-data',
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body: data
            }
            return fetch(BASE_URL + `/users/send_notifications/attachment`, body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default sendNotificationApi;